import { render } from "./gc-loader.vue?vue&type=template&id=679315b4&scoped=true"
const script = {}

import "./gc-loader.vue?vue&type=style&index=0&id=679315b4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679315b4"]])

export default __exports__